import { Box, IconButton, WorkflowHeader } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { FirmLogo } from '../../FirmLogo';

type Props = {
  title: string;
  exitToPath: string;
};

export const PageHeader: React.FC<Props> = ({ title, exitToPath }) => {
  const navigate = useNavigate();

  return (
    <Box css={{ borderBottom: '1px solid', borderColor: 'border', mb: 'space.500' }}>
      <WorkflowHeader css={{ width: '100%', maxWidth: '100%', px: '120px' }}>
        <WorkflowHeader.Leading>
          <FirmLogo />
        </WorkflowHeader.Leading>
        <WorkflowHeader.Title>{title}</WorkflowHeader.Title>
        <WorkflowHeader.Trailing>
          <IconButton name="X" label="Exit" spacing="compact" onClick={() => void navigate(exitToPath)} />
        </WorkflowHeader.Trailing>
      </WorkflowHeader>
    </Box>
  );
};
